import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { GetEngineer } from '../page/Get Engineer/GetEngineer'
import Home from '../page/Home/home'
import Payment from '../page/Payment/Payment'
import Service from '../page/ServicesTicket/Services'
import Ticket from '../page/ServicesTicket/Ticket'
import UserDetails from '../page/UserDetails/UserDetails'
import VerifyOtp from '../page/VerifyOtp/VerifyOtp'
import PrivateRoute from './PrivateRoute'

export default function Links() {
  return (
    <div className='h-full '>
      <Routes>
        {/* <Route path="/" element={<Home />} />
        <Route path='*' element={<Home />}></Route> */}
        <Route path="/" element={<UserDetails />} />
        <Route path='*' element={<UserDetails />}></Route>
        <Route path="/userdetails" element={<UserDetails/>} />  
        <Route path="/otp" element={<VerifyOtp />} />
        <Route path="/service" element={<PrivateRoute Component={Service} />} />
        <Route path="/ticket" element={<PrivateRoute Component={Ticket} />} />
        <Route path="/payment" element={<PrivateRoute Component={Payment} />} />
        <Route path="/getengineer" element={<PrivateRoute Component={GetEngineer} />} />
      </Routes>
    </div>
  )
}
